const LOGIN_PATH = '/login';
const NOT_WORTH_RETURNING_TO = new Set(['/', '/dashboard']);

export function safeReturnPath(value: string | string[] | undefined): string | null {
  const path = Array.isArray(value) ? value[0] : value;
  if (!path || !path.startsWith('/')) return null;
  if (path.startsWith('//') || path.includes('\\')) return null;
  const pathname = path.split(/[?#]/)[0];
  if (pathname === LOGIN_PATH) return null;
  return path;
}

export function loginHrefFor(pathname: string): string {
  const returnTo = safeReturnPath(pathname);
  if (!returnTo || NOT_WORTH_RETURNING_TO.has(returnTo)) return LOGIN_PATH;
  return `${LOGIN_PATH}?returnTo=${encodeURIComponent(returnTo)}`;
}
